import React, { useEffect, useState } from 'react';
import { CloudUpload, CheckCircle2 } from 'lucide-react';
import { onQueueChange, flushQueue } from '../lib/offlineSync';
import api from '../lib/api';

/**
 * SyncBadge — badge inline pour l'en-tête d'un module.
 *
 * Affiche le nombre de mutations concernant ce module qui n'ont pas encore atteint le serveur.
 *
 * Props :
 *   - urlPattern (string) : sous-chaîne à matcher (ex. "/shipments", "/rent-payments", "/clients")
 *   - label (string)       : suffixe optionnel (default "à synchroniser")
 *   - onClick               : callback (par défaut : déclenche flushQueue)
 */
export function SyncBadge({ urlPattern, label = 'à synchroniser', onClick }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const off = onQueueChange(setCount, urlPattern);
    return () => off?.();
  }, [urlPattern]);

  if (count === 0) return null;

  const handleClick = onClick || (() => flushQueue(api));

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center gap-1 bg-amber-100 border border-amber-300 text-amber-800 rounded-full px-2.5 py-1 text-[11px] font-bold hover:bg-amber-200 transition"
      title={`${count} modification(s) en attente — cliquez pour synchroniser`}
      data-testid={`sync-badge-${urlPattern.replace(/\//g, '') || 'all'}`}
    >
      <CloudUpload className="w-3 h-3" />
      Sync {count}
    </button>
  );
}

export default SyncBadge;
